<template>
  <div>

    <b-overlay class="b-overlay-liste" :show="showOverlay" rounded="sm">
      <ul class="list-group list-group-flush"> <!-- list-group list-group-flush -->

        <li v-for="suivi in suivis" :key="suivi.id" class="flex"> <!--list-group-item-->
          <div :class="['sent-msg', suivi.auteur == codePec? 'right' : 'left']"> <!-- <div class="sent-msg left"> si autre personne parle-->
            <!-- appliquer la classe : center si un seul, right si l'utilisateur courant qui parle, left si autre personne parle -->
            <span class="time-date"> {{ getTimeStampToDate(suivi.datesuivi) }}</span>
            <div class="shadow div-bubble pb-3 position-relative">
              <div class="sollicitation-action">
                <span class="badge badge-info">{{ suivi.libelleAction }}</span>
              </div>
              <div class="sollicitation-infos">
                {{ suivi.description }}
              </div>
              <p :class="['font-italic','position-absolute']" :style="[{'font-size':0.75+'em'}, (suivi.auteur == codePec)?{'left':5+'px'}:{'right':5+'px'}]" >{{suivi.libelleAuteur}}</p>
            </div>
          </div>
        </li>

      </ul>
    </b-overlay>

  </div>
</template>

<script>
import timeStampToDate from "../../js/timestampTranslation";

export default {
  name: "ListeSuiviBulle",
  props:{
    sollicitation: Object
  },
  data() {
    return {
      sollicitationID: this.sollicitation.id
    }
  },
  methods: {
    getTimeStampToDate(timestamp) {
      return timeStampToDate(timestamp)
    },
  }, computed: {
    suivis() {
      return this.$store.getters['suivis/getSuivisOrderByDate']
    },
    showOverlay() {
      if (this.$store.getters['suivis/suivis'] !== null)
        return false
      else
        return true
    },
    codePec() {
      return this.$store.getters['user/getCodePec'];
    }
  },
}
</script>

<style scoped>

li {
  list-style: none;
}

.b-overlay-liste {
  min-height: 50px;
  max-width: 400px;
  margin: 10px auto;
}


/* Style des box message */

.sollicitation-action {
  text-align: center;
  padding: 2px 0 0 0;
}

.sent-msg {
  width: 95%;
  min-width: 300px;
  margin-bottom: 20px;
  padding: 0 20px;
}

.sent-msg.center {
  margin: 0 auto 20px;
}

.sent-msg.left {
  float: left;
}

.sent-msg.right {
  float: right;
}

.time-date {
  color: #747474;
  display: block;
  font-size: 12px;
  /*position: absolute;
  top : 5px;
  left: 10px;*/
}

.sent-msg .div-bubble {
  position: relative;
  border-radius: .4em;
  background: var(--bubble-background-right);
  padding: 0px 5px;
}

.sent-msg.left .div-bubble {
  background: var(--bubble-background-left);
}

.sent-msg.right .div-bubble {
  background: var(--bubble-background-right);
}

.sent-msg .div-bubble:after {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 0;
  border: 0.938em solid transparent;
  border-bottom: 0;
  margin-left: -0.469em;
  margin-bottom: -0.937em;
}

.sent-msg.left .div-bubble:after {
  left: 5%;
  border-left: 0;
  border-top-color: var(--bubble-background-left);
}

.sent-msg.right .div-bubble:after {
  right: 5%;
  border-right: 0;
  border-top-color: var(--bubble-background-right);
}

/* fin Style des box message */

</style>